import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "../lib/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user

  useEffect(() => {
    const token = localStorage.getItem("argali_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("argali_token");
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("argali_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const setupOwner = async ({ name, email, password, phone }) => {
    const { data } = await api.post("/auth/setup", { name, email, password, phone });
    localStorage.setItem("argali_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout", {}); } catch { /* local logout still proceeds */ }
    localStorage.removeItem("argali_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, setupOwner, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
